import { create } from 'zustand';

interface CalendarStore {
  /** Per provider, bumped by every booking or reschedule made on the page: a
      leader's page also holds its teammates' pickers, which must not refetch. */
  versions: Record<string, number>;
  changed: (tutorUsername: string) => void;
}

/**
 * Several pickers can share one calendar on a page, and `router.refresh()` keeps
 * their client state: a grid fetched before a sibling card booked went on
 * offering the hour it took. The server stays the only judge of a slot.
 */
export const useCalendarStore = create<CalendarStore>((set) => ({
  versions: {},
  changed: (tutorUsername) =>
    set((s) => ({
      versions: { ...s.versions, [tutorUsername]: (s.versions[tutorUsername] ?? 0) + 1 },
    })),
}));
